module.exports = __webpack_public_path__ + "static/assets/2350006e06bff16048377f8ae157bca4.png";